import type { ManagerOptions, SocketOptions } from 'socket.io-client';

export type SocketConfig = {
  url: string;
  options: Partial<ManagerOptions & SocketOptions>;
};

function resolveSocketUrl(): string {
  const envUrl =
    process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_BACKEND_URL || '';

  if (envUrl) {
    if (envUrl.startsWith('http://') || envUrl.startsWith('https://')) {
      return envUrl;
    }

    if (envUrl.startsWith('/')) {
      return `${window.location.origin}${envUrl}`;
    }
  }

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000';
  }

  return window.location.origin;
}

function resolveSocketPath(): string {
  return process.env.REACT_APP_SOCKET_PATH || '/socket.io';
}

export function getSocketConfig(): SocketConfig {
  return {
    url: resolveSocketUrl(),
    options: { path: resolveSocketPath() },
  };
}

